import createdSvg from "../assets/img/created.svg";
import updatedSvg from "../assets/img/updated.svg";

const styles = {
  table: {
    width: "100%",
  } as React.CSSProperties,
  leftBlock: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    width: 74,
  } as React.CSSProperties,
  text: {
    fontSize: 12,
  } as React.CSSProperties,
  success: {
    color: "#3CAA6E",
    fontSize: 14,
  } as React.CSSProperties,
  separator: {
    background: "#00000021",
    width: 1,
    height: 19,
    margin: "0px 8px",
  } as React.CSSProperties,
  error: {
    color: "#FF4C56",
    fontSize: 14,
  } as React.CSSProperties,
  paddedCell: {
    paddingBottom: 12,
  } as React.CSSProperties,
};

interface BatchIntegrationData {
  created: { success: number; error: number };
  updated: { success: number; error: number };
  brandId?: number;
  logId?: string;
  message?: string;
}

const BatchIntegrationToast = (data: BatchIntegrationData) => {
  return (
    <table style={styles.table}>
      <tbody>
        <tr>
          <td style={styles.paddedCell}>
            <div style={styles.leftBlock}>
              <img src={createdSvg} alt="created" />
              <div style={styles.text}>Created:</div>
            </div>
          </td>
          <td style={styles.paddedCell}>
            <div style={styles.success}>Success {data.created.success}</div>
          </td>
          <td style={styles.paddedCell}>
            <div style={styles.separator} />
          </td>
          <td style={styles.paddedCell}>
            <div style={styles.error}>Error {data.created.error}</div>
          </td>
        </tr>
        <tr>
          <td>
            <div style={styles.leftBlock}>
              <img src={updatedSvg} alt="updated" />
              <div style={styles.text}>Updated:</div>
            </div>
          </td>
          <td>
            <div style={styles.success}>Success {data.updated.success}</div>
          </td>
          <td>
            <div style={styles.separator} />
          </td>
          <td>
            <div style={styles.error}>Error {data.updated.error}</div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default BatchIntegrationToast;
